export default __webpack_public_path__ + "static/media/LOGO-MINE-WATCH-final-blanco.73d3dd02.png";